var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Base-Expanded>=768/Logged-In","transform":"translate(-741.000000, -19.000000)","fill":"#A9B0B7"},React.createElement("g",{"id":"Group"},React.createElement("g",null,React.createElement("g",{"id":"Icons/Minor/Close-small-gray","transform":"translate(735.000000, 13.000000)"},React.createElement("path",{"d":"M13.4140955,12.000125 L17.7070061,7.70721443 C18.097998,7.31622258 18.097998,6.68423575 17.7070061,6.29324389 C17.3160142,5.90225204 16.6840274,5.90225204 16.2930356,6.29324389 L12.000125,10.5861545 L7.70721443,6.29324389 C7.31622258,5.90225204 6.68423575,5.90225204 6.29324389,6.29324389 C5.90225204,6.68423575 5.90225204,7.31622258 6.29324389,7.70721443 L10.5861545,12.000125 L6.29324389,16.2930356 C5.90225204,16.6840274 5.90225204,17.3160142 6.29324389,17.7070061 C6.48823983,17.902002 6.7442345,18 7.00022916,18 C7.25622383,18 7.5122185,17.902002 7.70721443,17.7070061 L12.000125,13.4140955 L16.2930356,17.7070061 C16.4880315,17.902002 16.7440262,18 17.0000208,18 C17.2560155,18 17.5120102,17.902002 17.7070061,17.7070061 C18.097998,17.3160142 18.097998,16.6840274 17.7070061,16.2930356 L13.4140955,12.000125 Z","id":"Icon"})))))));
}

X.displayName = "X";

X.defaultProps = {"width":"12px","height":"12px","viewBox":"0 0 12 12","version":"1.1"};

module.exports = X;

X.default = X;



//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/assets/icons/x.svg
// module id = 1386
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16